var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F24C4110-2E1F-4515-A87C-54630A24998B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.50434,14.1714 L16.37154,19.7856 L5.30334,23.4756 L11.50434,14.1714 Z M-3.52190156e-13,11.5137 L8.2188,12.6099 L2.2374,21.5847 L-3.52190156e-13,11.5137 Z M22.11894,10.33542 L18.28134,18.01062 L12.87774,11.33622 L22.11894,10.33542 Z M10.99692,-1.57558466e-13 L9.77112,9.1854 L1.72512,8.1126 L10.99692,-1.57558466e-13 Z M14.589,0.29718 L21.3732,8.21178 L13.4082,9.14958 L14.589,0.29718 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7413733,35.3757625 L43.0726193,47.3665593 C44.0949917,48.5524422 43.2566828,50.4 41.6948768,50.4 L41.6948768,50.4 L12.8370041,50.4 C11.380898,50.4 10.5134305,48.7687238 11.3207584,47.5498488 L11.3207584,47.5498488 L15.5742649,41.1310517 L32.7413733,35.3757625 Z M51.9645254,22.2564524 C53.2383904,22.1061551 54.2625852,23.290205 53.9400185,24.5384063 L53.9400185,24.5384063 L48.8646048,44.1100554 C48.4946555,45.5360475 46.6850017,45.961279 45.7245913,44.8468791 L45.7245913,44.8468791 L35.2275059,32.6654612 L39.6796551,23.7099379 Z M0.0841387656,24.7347093 C-0.311324347,23.4553488 0.743851424,22.1961502 2.06509915,22.373941 L2.06509915,22.373941 L9.86501677,23.4186909 L13.1307767,38.2083179 L9.19619206,44.1450637 C8.34512628,45.42809 6.39514687,45.1458242 5.93954421,43.6740098 L5.93954421,43.6740098 Z M29.7604562,1.59258138 C29.9499869,0.159257763 31.641184,-0.498751418 32.74192,0.432359067 L32.74192,0.432359067 L50.6489271,15.6123926 C51.8699423,16.6461452 51.2721916,18.6458333 49.6866943,18.8327885 L49.6866943,18.8327885 L39.6925942,20.0168385 L28.9841092,7.4523456 Z M22.9745278,1.43806836 C24.266617,0.459302618 26.0926725,1.53154599 25.8794504,3.14449329 L25.8794504,3.14449329 L25.389222,6.83411023 L10.629518,19.8238347 L4.91443821,19.0558518 C3.29795996,18.8395702 2.75488158,16.7629006 4.05790521,15.7768033 L4.05790521,15.7768033 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.1-WebPageBuilder-EmptyWidgets",
    transform: "translate(-478.000000, -710.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(336.000000, 540.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Radar-Chart/40dp",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(22.379580, 22.769640)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.379580, -22.769640)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(9.000776, 10.799840)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000776, -10.799840)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarChart);
export default __webpack_public_path__ + "static/media/radarChart.1ac59bb68260c2cf8e2e6f1e166b8a1f.svg";
export { ForwardRef as ReactComponent };